export class CreateDepartmentRequest
{    
    public code: string;
    public name: string;
    public programId: string;
    public projectId: string;
    public companyId: string;
}